<template>
  <span>
    <generic-filter-options
        :static-search="staticSearch"
        agency-label="Verstrekker"
        @generic-filter-options-request="setGenericFilterOptions($event)"
    />

    <div class="filter-option">
      Passeer datum
      <a-range-picker
          :default-picker-value="[moment().subtract(1, 'months'), moment()]"
          :placeholder="['Startdatum', 'Einddatum']"
          :format="dateFormatEnum.DISPLAY_DATE"
          @change="setFilterDateRange"
          style="width: 220px"
          :allow-clear="true"
          :ranges="{
            'Vorige maand': [
                moment().subtract(1, 'months').startOf('month'),
                moment().subtract(1, 'months').endOf('month')
              ],
            'Deze maand': [
                moment().startOf('month'),
                moment().endOf('month')
              ],
           }"
      >
        <a-icon slot="suffixIcon" type="calendar"/>
      </a-range-picker>
    </div>
  </span>
</template>

<script>
import GenericFilterOptions from "../components/GenericFilterOptions";
import locale from 'ant-design-vue/es/date-picker/locale/nl_NL';
import DateFormatEnum from "~/enums/DateFormatEnum";
import moment from "moment";

export default {
  name: "StaticSelectionMortgageFilterComponent",
  props: {
    staticSearch: {
      type: Object,
      required: true,
    },
  },
  components: {
    GenericFilterOptions
  },
  data() {
    return {
      locale,
      filter: {
        dateRange: [],
      },
      dateFormatEnum: DateFormatEnum,
    }
  },
  methods: {
    emitFilterRequest() {
      this.$emit('filter-request', this.filter);
    },
    moment,
    setFilterDateRange(date) {
      this.filter.dateRange = [];
      if (date.length) {
        this.filter.dateRange[0] = date[0].startOf('day').format(DateFormatEnum.DB_ENTRY);
        this.filter.dateRange[1] = date[1].endOf('day').format(DateFormatEnum.DB_ENTRY);
      }
      this.emitFilterRequest();
    },
    setGenericFilterOptions(value) {
      this.filter = value;
      this.emitFilterRequest();
    }
  },
}
</script>

<style scoped>
.filter-option {
  display: inline-block;
  margin-left: 5px;
  height: 45px
}
</style>